import React from "react";
import Select from "react-select";
import BackButton from "./back-button.jsx";
import TableRefreshIndicator from "./table-refresh-indicator.jsx";

const HEADER_STYLE = {
  lineHeight: 1.2
};

const AnalyticsHeader = (
  {
    eventBucket,
    allEventBuckets,
    subpath,
    query,
    label,
    onRefresh,
    isRefreshing,
    hideHeader
  },
  { router }
) => {
  return (
    <div>
      <BackButton
        label="Analytics"
        style={{ marginBottom: 10 }}
        location={`/event_buckets/${eventBucket.id}/analytics`}
      />

      {onRefresh || isRefreshing ? (
        <TableRefreshIndicator
          onRefresh={onRefresh}
          isRefreshing={isRefreshing}
          style={{ marginRight: 260, marginTop: -2 }}
        />
      ) : null}

      <div style={{ float: "right", width: 250 }}>
        <Select
          options={allEventBuckets.map(b => ({ label: b.name, value: b.id }))}
          value={eventBucket.id}
          clearable={false}
          onChange={b =>
            router.push({
              pathname: `/event_buckets/${b.value}/analytics/${subpath}`,
              query
            })
          }
        />
      </div>

      {!hideHeader ? (
        <h1 style={HEADER_STYLE}>
          "{eventBucket.name}" {label}
        </h1>
      ) : null}
    </div>
  );
};

AnalyticsHeader.contextTypes = {
  router: React.PropTypes.object
};

export default AnalyticsHeader;



// WEBPACK FOOTER //
// ./src/app/components/partials/analytics-header.jsx